import { FileJson, FileSpreadsheet } from 'lucide-react';
import { useExportData } from '@/hooks/useExportData';
import { T, RADIUS } from '@/lib/tokens';

const btnStyle = (disabled: boolean): React.CSSProperties => ({
  padding: '8px 14px',
  borderRadius: RADIUS.sm,
  background: T.surface,
  color: T.textSec,
  border: `1px solid ${T.border}`,
  fontSize: 13,
  fontWeight: 600,
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.6 : 1,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontFamily: 'inherit',
});

/**
 *
 */
export function DataExportCard() {
  const { exportItems, exportLoanHistory, isExportingItems, isExportingLoans } = useExportData();

  return (
    <div style={{ padding: 16 }}>
      <p style={{ fontSize: 13, color: T.textMuted, lineHeight: 1.65, margin: '0 0 16px' }}>
        Download your items and loan history
      </p>

      <div style={{ marginBottom: 16 }}>
        <p
          style={{
            fontSize: 12,
            color: T.textSec,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            margin: '0 0 8px',
          }}
        >
          My Items
        </p>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            style={btnStyle(isExportingItems)}
            onClick={() => exportItems('csv')}
            disabled={isExportingItems}
          >
            <FileSpreadsheet width={14} height={14} />
            CSV
          </button>
          <button
            style={btnStyle(isExportingItems)}
            onClick={() => exportItems('json')}
            disabled={isExportingItems}
          >
            <FileJson width={14} height={14} />
            JSON
          </button>
        </div>
      </div>

      <div>
        <p
          style={{
            fontSize: 12,
            color: T.textSec,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            margin: '0 0 8px',
          }}
        >
          Loan History
        </p>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            style={btnStyle(isExportingLoans)}
            onClick={() => exportLoanHistory('csv')}
            disabled={isExportingLoans}
          >
            <FileSpreadsheet width={14} height={14} />
            CSV
          </button>
          <button
            style={btnStyle(isExportingLoans)}
            onClick={() => exportLoanHistory('json')}
            disabled={isExportingLoans}
          >
            <FileJson width={14} height={14} />
            JSON
          </button>
        </div>
      </div>
    </div>
  );
}
